/* eslint-disable max-lines */
export const singleUnitTemplateLarge = {
  id: 'simpleContainer1',
  view: 'LayoutGrid',
  options: {
    columns: 3,
  },
  childNodes: [
    {
      id: 'property-top',
      view: 'LayoutGridItem',
      options: {
        colSpan: 3,
      },
      childNodes: [
        {
          id: 'property-gallery-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyGallery',
            linkName: 'Property Gallery',
          },
          childNodes: [
            {
              id: 'property-gallery',
              view: 'PropertyGallery',
            },
          ],
        },
        {
          id: 'property-navigation-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyNavigation',
            linkName: 'Property Navigation',
          },
          childNodes: [
            {
              id: 'property-navigation',
              view: 'PropertyNavigation',
            },
          ],
        },
      ],
    },
    {
      id: 'column-1',
      view: 'LayoutGridItem',
      options: {
        colSpan: 2,
      },
      childNodes: [
        {
          id: 'property-summary-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertySummary',
            linkName: 'Property Summary',
          },
          childNodes: [
            {
              id: 'property-summary',
              view: 'SingleOfferSummaryWrapper',
            },
          ],
        },
        {
          id: 'property-level-message-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyLevelMessage',
            linkName: 'Property Level Message',
          },
          childNodes: [
            {
              id: 'message-card',
              view: 'SharedUiPropertyLevelOffersMessageWrapper',
            },
          ],
        },
        {
          id: 'property-space-details-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertySpaceDetails',
            linkName: 'Property Space Details',
          },
          childNodes: [
            {
              id: 'space-details',
              view: 'SpaceDetailsWrapper',
            },
          ],
        },
        {
          id: 'property-about-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyAbout',
            linkName: 'Property About',
          },
          childNodes: [
            {
              id: 'about-property',
              view: 'AboutThisPropertyWrapper',
              options: {
                columns: 1,
              },
            },
          ],
        },
      ],
    },
    {
      id: 'column-2',
      view: 'LayoutGridItem',
      options: {
        colSpan: 1,
      },
      childNodes: [
        {
          id: 'SingleOfferPricebox',
          view: 'SingleOfferPriceWrapper',
        },
      ],
    },
    {
      id: 'property-info',
      view: 'LayoutGridItem',
      options: {
        colSpan: 3,
      },
      childNodes: [
        {
          id: 'property-amenities-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyAmenities',
            linkName: 'Property Amenities',
          },
          childNodes: [
            {
              id: 'property-amenities',
              view: 'SharedUiAmenityDescriptionWrapper',
            },
          ],
        },
        {
          id: 'property-similar-ads-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyMesoCarousel',
            linkName: 'Similar property ads',
          },
          childNodes: [
            {
              id: 'property-similar-ads',
              view: 'SimilarHotelsMesoWrapper',
            },
          ],
        },
        {
          id: 'property-similar-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertySimilar',
            linkName: 'Property Similar',
          },
          childNodes: [
            {
              id: 'property-similar',
              view: 'SharedUiSimilarPropertiesWrapper',
            },
          ],
        },
        {
          id: 'property-policies-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyPolicies',
            linkName: 'Property policies',
          },
          childNodes: [
            {
              id: 'property-policies',
              view: 'SharedUiPoliciesWrapper',
            },
          ],
        },
        {
          id: 'property-important-info-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyImportantInfo',
            linkName: 'Property Important Info',
          },
          childNodes: [
            {
              id: 'property-imp-info',
              view: 'SharedUiImportantInfoWrapper',
            },
          ],
        },
        {
          id: 'property-whats-around-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyWhatsAround',
            linkName: 'Property whats around',
          },
          childNodes: [
            {
              id: 'whats-around',
              view: 'SharedUiWhatsAroundWrapper',
            },
          ],
        },
        {
          id: 'activities-recommendations-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.ActivitiesRecommendations',
            linkName: 'activities recommendations',
          },
          childNodes: [
            {
              id: 'activities-recommendations',
              view: 'ActivityRecommendationsWrapper',
            },
          ],
        },
        {
          id: 'property-reviews-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyReviews',
            linkName: 'Property Reviews',
          },
          childNodes: [
            {
              id: 'property-reviews',
              view: 'SharedUiPropertyReviewsWrapper',
            },
          ],
        },
      ],
    },
  ],
};

export const singleUnitTemplateSmall = {
  id: 'simpleContainer1',
  view: 'LayoutGrid',
  options: {
    columns: 1,
  },
  childNodes: [
    {
      id: 'single-unit-vr',
      view: 'LayoutGridItem',
      options: {
        colSpan: 1,
      },
      childNodes: [
        {
          id: 'property-quick-reserve',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyQuickReserve',
            linkName: 'Property Quick Reserve',
          },
          childNodes: [
            {
              id: 'property-quick-reserve',
              view: 'SharedUiStickyBookBarWrapper',
            },
          ],
        },
        {
          id: 'property-top',
          view: 'LayoutGridItem',
          options: {
            colSpan: 3,
          },
          childNodes: [
            {
              id: 'property-gallery-tracker',
              view: 'IntersectionTrackerWrapper',
              options: {
                rfrrId: 'HOT.HIS.SU.VR.PropertyGallery',
                linkName: 'Property Gallery',
              },
              childNodes: [
                {
                  id: 'property-gallery',
                  view: 'PropertyGallery',
                },
              ],
            },
            {
              id: 'property-navigation-tracker',
              view: 'IntersectionTrackerWrapper',
              options: {
                rfrrId: 'HOT.HIS.SU.VR.PropertyNavigation',
                linkName: 'Property Navigation',
              },
              childNodes: [
                {
                  id: 'property-navigation',
                  view: 'PropertyNavigation',
                },
              ],
            },
          ],
        },
        {
          id: 'property-summary-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertySummary',
            linkName: 'Property Summary',
          },
          childNodes: [
            {
              id: 'property-summary',
              view: 'SingleOfferSummaryWrapper',
            },
          ],
        },
        {
          id: 'property-level-message',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyLevelMessage',
            linkName: 'Property Level Message',
          },
          childNodes: [
            {
              id: 'message-card',
              view: 'SharedUiPropertyLevelOffersMessageWrapper',
            },
          ],
        },
        {
          id: 'property-price-box',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyPricebox',
            linkName: 'Property Price box',
          },
          childNodes: [
            {
              id: 'SingleOfferPricebox',
              view: 'SingleOfferPriceWrapper',
            },
          ],
        },
        {
          id: 'property-space-details',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertySpaceDetails',
            linkName: 'Property Space Details',
          },
          childNodes: [
            {
              id: 'space-details',
              view: 'SpaceDetailsWrapper',
            },
          ],
        },
        {
          id: 'property-about',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyAbout',
            linkName: 'Property About',
          },
          childNodes: [
            {
              id: 'about-property',
              view: 'AboutThisPropertyWrapper',
              options: {
                columns: 1,
              },
            },
          ],
        },
        {
          id: 'property-amenities-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyAmenities',
            linkName: 'Property Amenities',
          },
          childNodes: [
            {
              id: 'property-amenities',
              view: 'SharedUiAmenityDescriptionWrapper',
            },
          ],
        },
        {
          id: 'property-similar-ads-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyMesoCarousel',
            linkName: 'Similar property ads',
          },
          childNodes: [
            {
              id: 'property-similar-ads',
              view: 'SimilarHotelsMesoWrapper',
            },
          ],
        },
        {
          id: 'property-similar-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertySimilar',
            linkName: 'Property Similar',
          },
          childNodes: [
            {
              id: 'property-similar',
              view: 'SharedUiSimilarPropertiesWrapper',
            },
          ],
        },
        {
          id: 'property-policies-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyPolicies',
            linkName: 'Property policies',
          },
          childNodes: [
            {
              id: 'property-policies',
              view: 'SharedUiPoliciesWrapper',
            },
          ],
        },
        {
          id: 'property-important-info-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyImportantInfo',
            linkName: 'Property Important Info',
          },
          childNodes: [
            {
              id: 'property-imp-info',
              view: 'SharedUiImportantInfoWrapper',
            },
          ],
        },
        {
          id: 'property-whats-around-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyWhatsAround',
            linkName: 'Property whats around',
          },
          childNodes: [
            {
              id: 'whats-around',
              view: 'SharedUiWhatsAroundWrapper',
            },
          ],
        },
        {
          id: 'activities-recommendations-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.ActivitiesRecommendations',
            linkName: 'activities recommendations',
          },
          childNodes: [
            {
              id: 'activities-recommendations',
              view: 'ActivityRecommendationsWrapper',
            },
          ],
        },
        {
          id: 'property-reviews-tracker',
          view: 'IntersectionTrackerWrapper',
          options: {
            rfrrId: 'HOT.HIS.SU.VR.PropertyReviews',
            linkName: 'Property Reviews',
          },
          childNodes: [
            {
              id: 'property-reviews',
              view: 'SharedUiPropertyReviewsWrapper',
            },
          ],
        },
      ],
    },
  ],
};
